// Decides which lead or account choices match the search while retaining a valid picked record.
export function subjectChoices({ type, query, leads, accounts, pickedId } = {}) {
  const list = type === 'lead'
    ? (leads || []).filter((l) => !l.archived).map((l) => ({ id: l.id, label: l.name || l.company || l.email || 'Lead' }))
    : (accounts || []).map((a) => ({ id: a.id, label: a.name || 'Account' }));
  const needle = String(query ?? '').trim().toLowerCase();
  if (!needle) return list;
  const hits = list.filter((o) => o.label.toLowerCase().includes(needle));
  const picked = pickedId ? list.find((o) => o.id === pickedId) : null;
  return picked && !hits.some((o) => o.id === picked.id) ? [picked, ...hits] : hits;
}
